import * as React from "react";
import { SimpleShowLayout, Show, ImageField } from "react-admin";

import TextField from "../components/TextField";
import LayoutContainer from "../components/LayoutContainer";
import PriviledgeField from "../components/ProviledgeField";
import TierConditionField from "../components/TierConditionField";
const TierShow = (props) => (
  <LayoutContainer>
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" label="Tier name" />
        <TextField source="level" label="Level" />
        <ImageField source="image_url" label="image" />
        <TierConditionField />
        <PriviledgeField />
        <TextField source="time" label="Created time" />
      </SimpleShowLayout>
    </Show>
  </LayoutContainer>
);

export default TierShow;
